import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { LoanApplication } from "../schema/loan-appication/loan-application";
import { Borrower } from "../schema/loan-appication/borrower";
import { Address } from "@data/schema/loan-appication/address";
import { Employment } from "@data/schema/loan-appication/employment";
import { ReferenceContact } from "@data/schema/loan-appication/reference-contact";
import { MilitaryDetail } from "@data/schema/loan-appication/military-detail";
import { Counselling } from "@data/schema/loan-appication/counselling";
import { IncomeAssertVerification } from "@data/schema/loan-appication/income-assert-verification";
import { LoanInfo } from "@data/schema/loan-appication/loan-info";
import { Assets } from "@data/schema/loan-appication/assets";
import {Liability} from '@data/schema/loan-appication/liabilities';
import {REO} from '@data/schema/loan-appication/reo';
import {LoanApplicationConstant} from '@data/service/loan-application-constant';
import {EmploymentIncome} from '@data/schema/loan-appication/employment-income';
@Injectable({
  providedIn: "root"
})
export class LoanApplicationService {
  constructor(private http: HttpClient,private loanApplicationConstants : LoanApplicationConstant) {}

  getLoanApplication(): Observable<LoanApplication[]> {
    return of(<LoanApplication[]>JSON.parse(localStorage.getItem("loanApp")));
  }
  getLoanApplicationById(id: string): Observable<LoanApplication> {
    const loanApp = <LoanApplication>(
      JSON.parse(localStorage.getItem("loanApp"))
    );
    if (!loanApp) {
      localStorage.setItem(
        "loanApp",
        JSON.stringify(this.getTestLoanApplicationList())
      );
    }
    const loanApp1 = <LoanApplication>(
      JSON.parse(localStorage.getItem("loanApp"))
    );
    return of(loanApp1);
  }
  updateLoanApplication(
    loanApplication: LoanApplication
  ): Observable<LoanApplication> {
    localStorage.setItem("loanApp", JSON.stringify(loanApplication));
    return of(loanApplication);
  }

  /***
   * Define your test json data here
   */
  getTestLoanApplicationList(): LoanApplication {
    let borrower = [];
    let borrower1 = new Borrower();
    let coborrower = new Borrower();
    let currentEmployment = new Employment();
    let previousEmployment = new Employment();

    //employment
    let income = new EmploymentIncome();
    income.sTotalEmploymentIncome = 200000;
    income.sBaseIncome = 3000;
    income.sNonEmploymentIncome =[];
    currentEmployment.sIncomes = income;
    previousEmployment.sIncomes = income;

    let reo = new REO();
    let currentAddress = new Address();
    let previousAddress = new Address();
    borrower1.sCurrentAddress = currentAddress;
    previousAddress.sAddrStreet = "7950 Street Current";
    currentAddress.sAddrStreet = "7940 Highsmith ct";
    //previous address is a array
    borrower1.sPreviousAddress[0] = previousAddress;
    borrower1.sSSN = "111111111";
    borrower1.sFirstName = "George";
    borrower1.sLastName = "Peter";
    borrower1.sMiddleName = "Peter";
    borrower1.sSuffixName = "Mr";
    borrower1.sCitizenShip = "";
    borrower1.uiShow = false;
    borrower1.id="101";

    coborrower.sCurrentAddress = currentAddress;
    coborrower.sPreviousAddress[0] = previousAddress;
    coborrower.sSSN = "111111111";
    coborrower.sFirstName = "Taya";
    coborrower.sLastName = "Antony";
    coborrower.sMiddleName = "Peter";
    coborrower.sSuffixName = "Mr";
    coborrower.sCitizenShip = "";
    coborrower.uiShow = false;
    borrower1.uiArrow = "arrow-up-outline";
    coborrower.uiArrow = "arrow-up-outline";
    coborrower.id="102"

    borrower1.sNearestLivingRelative = new ReferenceContact();
    borrower1.sNearestLivingRelative.sAddress = currentAddress;
    coborrower.sNearestLivingRelative = new ReferenceContact();
    coborrower.sNearestLivingRelative.sAddress = currentAddress;
    borrower1.sNearestLivingRelative.sContactName = "George";
    coborrower.sNearestLivingRelative.sContactName = "Taya";

    borrower1.sMilitaryDetail = new MilitaryDetail();
    borrower1.sMilitaryDetail.sActiveDuty = true;
    coborrower.sMilitaryDetail = new MilitaryDetail();
    coborrower.sMilitaryDetail.sActiveDuty = false;

    borrower1.sCounselling = new Counselling();
    coborrower.sCounselling = new Counselling();
    borrower1.sCounselling.sCompleteDate = "10/10/2023";
    coborrower.sCounselling.sCompleteDate = "10/10/2023";

    borrower1.sIncomeAssetVerification = [];
    let incomeAndAsset = new IncomeAssertVerification();
    incomeAndAsset.sContact = "test";
    borrower1.sIncomeAssetVerification.push(incomeAndAsset);
    coborrower.sIncomeAssetVerification = [];
    coborrower.sIncomeAssetVerification.push(incomeAndAsset);


    //llability
    let liability = new Liability();
    let liability2 = new Liability();
    liability.sOwner = "george Peter"
    liability.sType="101"
    liability.sResubodinationFlag=true;
    liability.sBalance = 2000;
    liability.sAccountNo = "1234";
    liability.sCreditorName = "Liabilit1";
    liability.sMonthlyPayment = 1000
    liability.sRemainingTerm=8;
    liability.sPayoffFlag = true;
    liability.sOmitFlag = true;
    liability.id="100"
    liability2.sOwner = "george Peter"
    liability2.sType="101"
    liability2.sResubodinationFlag=true;
    liability2.sBalance = 5000;
    liability2.sAccountNo = "1234";
    liability2.sCreditorName = "Liability2";
    liability2.sMonthlyPayment = 1000
    liability2.sRemainingTerm=8;
    liability2.sPayoffFlag = true;
    liability2.sOmitFlag = true;
    liability2.id="101"
    borrower1.sLiabilities.push(liability);
    borrower1.sLiabilities.push(liability2);
    coborrower.sLiabilities.push(liability);
    coborrower.sLiabilities.push(liability2);






    let loanInfo = new LoanInfo();
    loanInfo.sLoanPurpose = "Purchase";
    loanInfo.sLoanAmount = 500000;
    loanInfo.sLoanType = "Conventional";
    loanInfo.sAmountPaidInCash = 100000;
    loanInfo.sHOA = 500;
    loanInfo.sDownpaymentAmount = 20000;
    loanInfo.sNoteRate = 0.08;
    loanInfo.sAppraisalValue = 600000;
    loanInfo.sAUSType = "DU";
    loanInfo.sAnnualMIRate = 0.08;
    loanInfo.sProgram = "30 Year Conventional";
    loanInfo.sMiddleCreditScore = 700;
    loanInfo.sOccupancy = "Owner Occupied";
    loanInfo.sBranch = "Local";
    loanInfo.sLoanStatus = "Registerd";
    loanInfo.sSubjectAddress = currentAddress;
    loanInfo.sMiddleCreditScore = 700;
    loanInfo.sLTV = 0.9;
    loanInfo.sCLTV = 0.9;
    loanInfo.sHCLTV = 0.9;
    loanInfo.sAPR = 0.029;
    loanInfo.sDTI = 0.022;
    loanInfo.sExpense = 93333;
    loanInfo.sLockStatus = "Lock Pending Manual";
    loanInfo.sLockDate = "02/02/2023";
    loanInfo.sLockExpired = "02/02/2023";
    loanInfo.sCompensation = "0.0000";
    loanInfo.sRequestddRate = 0.027;
    loanInfo.sTotalLockPrice = 1.02;

    //asset and liability
    let assets = [];
    let asset = new Assets();
    asset.sAccountNo = "1234";
    asset.sBankName = "Test";
    asset.sCashValue = 10000.0;
    asset.sBankAddress = currentAddress;
    asset.sType = "101";
    assets.push(asset);
    assets.push(asset);
    assets.push(asset);
    borrower1.sAssets = assets;
    coborrower.sAssets = assets;

    //REO
    reo.sPropertyType="101";
    reo.sDisposition="101";
    reo.sOccupancy="101";
    reo.sSubjectFlag=true;
    reo.sCurrentFlag=true;
    reo.sMarketValue=100000;
    reo.sMortgageLien=1000
    reo.sMortgagePayment=1000
    reo.sTaxExpense = 100;
    reo.sGrossRental = 300;
    reo.sOccupancyRate=100
    reo.sNetRentalIncome = 1000;
    reo.sAddress = currentAddress;
    reo.sLiabilities = []
    reo.uiArrow = "arrow-down-outline"

    borrower1.sREO.push(reo);
    coborrower.sREO.push(reo);

    //declarations
    borrower1.sDeclaration = this.loanApplicationConstants.getDeclarations();
    coborrower.sDeclaration =  this.loanApplicationConstants.getDeclarations();

    //demographics
    borrower1.sDemograhics = this.loanApplicationConstants.getDemographics();
    coborrower.sDemograhics =  this.loanApplicationConstants.getDemographics();
    //employment income
    let employmentIncome = new EmploymentIncome();
    employmentIncome.sTotalEmploymentIncome = 500000;
    employmentIncome.sBaseIncome = 2000;
    employmentIncome.sNonEmploymentIncome =[];
    borrower1.sEmploymentIncome = employmentIncome;
    coborrower.sEmploymentIncome = employmentIncome;




    borrower1.sCurrentEmployments[0] = currentEmployment;
    borrower1.sPreviousEmployments[0] = previousEmployment;
    coborrower.sCurrentEmployments[0] = currentEmployment;
    coborrower.sPreviousEmployments[0] = previousEmployment;
    currentEmployment.sName = "wallmart";
    currentEmployment.sIsPrimaryEmploymentFlag = true;
    previousEmployment.sName = "Best Buy";
    let loanApp1 = new LoanApplication();
    let loanApp2 = new LoanApplication();
    let loanApp3 = new LoanApplication();
    loanApp1.id = "1";
    borrower.push(borrower1);
    borrower.push(coborrower);
    loanApp1.borrower = borrower;
    loanApp2.id = "2";
    loanApp3.id = "3";
    loanApp1.sLoanInfo = loanInfo;

    loanApp1.borrower = borrower;
    loanApp2.borrower = borrower;
    loanApp3.borrower = borrower;

    return loanApp1;
  }
}
export enum BUTTON_EVENTS {
  SAVE_AND_CLOSE = "SAVE_AND_CLOSE",
  CLOSE = "CLOSE"
}
